import { combineReducers } from "redux";
import masters from "./masters";
import customers from "./customers";

import dashboard from "./dashboard";
import layout from "./layout";
import products from "./product";
import sales from "./sales"
import transaction from "./transaction";
import complaints from "./complaints";
export const reducers = combineReducers({
  masters,
  complaints,
  layout,
  dashboard,
  products,
  customers,
  sales,
  transaction

});
